export function isPurchaseIntentFlowEnabled(email?: string): boolean {
  const flag = import.meta.env.VITE_PURCHASE_INTENT_FLOW_ENABLED
  const allowedEmails = import.meta.env.VITE_PURCHASE_INTENT_FLOW_ALLOWED_EMAILS

  if (email && allowedEmails) {
    const list = (allowedEmails as string).split(',').map((e: string) => e.trim())
    if (list.includes(email)) return true
  }

  return flag === true || flag === 'true'
}
